import React from 'react'

export default function ProductsInventoryInnerStyle() {
  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        /* Modify Parent Style Content Inner */
        #content { background-color: whitesmoke; }

        .report-wrapper { border: solid 0.5px lightgrey; }

        #products-list-container {
          font-size: 1rem;
          background-color: white;
          box-sizing: border-box;
          padding: 25px;
        }

        .firstpage, .pagebreak { margin-bottom: 25px; }
        .lastpage { margin-bottom: 0; }

        .products-list-contents-wrapper {
          border: none;
          border-left: solid 0.5px darkgrey;
          padding-left: 10px;
        }

        .products-inventory-header { font-weight: bold; }

        #warehouse-inventory-container {
          margin: 10px 0;
        }

        .inventory-table {
          width: 100%;
        }

        .inventory-table th:nth-child(1), .inventory-table td:nth-child(1) {
          width: 45%;
        }
        .inventory-table th:nth-child(2), .inventory-table td:nth-child(2) {
          width: 25%;
        }
        .inventory-table th:nth-child(3), .inventory-table td:nth-child(3) {
          width: 15%;
        }
        .inventory-table th:nth-child(4), .inventory-table td:nth-child(4) {
          width: 15%;
        }
      `}
      </style>
    </React.Fragment>
  )
}
